import React from 'react';
import {Tabs, Cell, Input, Toast} from 'zarm';
import {Observable} from '@utils';
import './index.less';
import utils from '@seeing/utils';
import {ShowMediaCell} from '@wap/components';
// 配适评估

const {Panel} = Tabs;

// 可选文字列表 先写死
const typeList = [
  {
    value: '配适良好',
    label: '配适良好',
  },
  {
    value: '正位、荧光好、活动度正常',
    label: '（正位、荧光好、活动度正常）',
    special: 1, // 样式特殊处理
  },
  {value: '正位', label: '正位'},
  {value: '轻度', label: '轻度'},
  {value: '中度', label: '中度'},
  {value: '重度', label: '重度'},
  {value: '偏鼻侧', label: '偏鼻侧'},
  {value: '偏颞侧', label: '偏颞侧'},
  {value: '偏上方', label: '偏上方'},
  {value: '偏下方', label: '偏下方'},
  {value: '荧光偏松', label: '荧光偏松'},
  {value: '荧光好', label: '荧光好'},
  {value: '荧光偏紧', label: '荧光偏紧'},
  {value: '活动度偏大', label: '活动度偏大'},
  {value: '活动度正常', label: '活动度正常'},
  {value: '活动度偏小', label: '活动度偏小'},
];
class TryAccessExamItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitParams: {
        list: [{dataOsAssess: '', dataOdAssess: ''}],
      }, // 提交的参数
      submitMediaParams: props.data.examFiles || [], // 提交的视频参数
      tabKey: 0,
    };
  }

  odRuleRef = {};

  osRuleRef = {};

  componentDidMount() {
    const {examContent, examFiles = []} = this.props.data;
    const obj = {
      list: [{dataOsAssess: '', dataOdAssess: ''}],
    };
    this.setState({
      submitParams: examContent.list ? examContent : obj,
      submitMediaParams: examFiles,
    });

    // 图片查看器，图片查看器的touchmove会穿透
    // 导致tabs也跟着切换
    // 利用自定义事件发布订阅解决这个问题
    this.unSubscriber = Observable.subscribe('swipe', (visible) => {
      if (visible) {
        this.currentTabKey = this.state.tabKey;
      } else {
        document
          .querySelectorAll('.examItemTabCont .za-tabs__tab')
          .forEach((dom, index) => {
            if (this.currentTabKey === index) {
              dom.click();
            }
          });
      }
    });
  }

  componentWillUnmount() {
    this.unSubscriber();
  }

  /**
   * 处理好的数据成传给保存提交
   * @returns
   */
  handleResult = () => {
    const {submitParams, submitMediaParams} = this.state;
    const params = utils.copy(this.props.data);
    params.whichTimes = params.examTimes;
    params.examFiles = submitMediaParams;
    params.examContent = submitParams;
    return params;
  };

  // 插入文字
  insertText = (val) => {
    const {tabKey, submitParams} = this.state;
    let arr = {...submitParams};
    const keyMap = new Map([
      [0, {value: arr.list[0].dataOdAssess || '', key: 'dataOdAssess'}],
      [1, {value: arr.list[0].dataOsAssess || '', key: 'dataOsAssess'}],
    ]);
    let [props, position, content] = ['', {start: 0, end: 0}, ''];
    // 获取odValue还是osValue
    const assessObj = utils.copy(keyMap.get(tabKey));
    const assessValue = assessObj.value;
    content = assessValue.length;
    if (content > 100) {
      return Toast.show('最多输入100个字符');
    }
    props = this.odRuleRef.input.input; // 获取dom节点实例
    if (assessObj.key === 'dataOsAssess') props = this.osRuleRef.input.input;
    position = this.getPositionForTextArea(props); // 光标的位置
    let newValue = '';
    // 判断是前后插入还是中间插入 相等为前后插入
    const insertPos =
      position.start === position.end ? position.start : position.end;
    newValue =
      assessValue.slice(0, insertPos) +
      `${val.value},` +
      assessValue.slice(insertPos);
    arr.list[0][`${assessObj.key}`] = newValue;
    this.setState(
      {
        submitParams: arr,
      },
      () => {
        // 光标定位到相应的位置
        props.focus();
        // document.activeElement.blur();
        props.selectionStart = position.start + val.value.length + 1;
        props.selectionEnd = position.end + val.value.length + 1;
      }
    );
  };

  // 音视频数据改变
  onMediaChange = (record) => {
    this.setState({
      submitMediaParams: record,
    });
  };

  /**
   * tab改变
   */
  onTableChange = (active) => {
    this.setState({tabKey: active});
  };

  // 获取光标位置
  getPositionForTextArea = (ctrl) => {
    // 获取光标位置
    let CaretPos = {
      start: 0,
      end: 0,
    };
    if (ctrl?.selectionStart) {
      // Firefox support
      CaretPos.start = ctrl.selectionStart;
    }
    if (ctrl.selectionEnd) {
      CaretPos.end = ctrl.selectionEnd;
    }
    return CaretPos;
  };

  // 设置光标到插入位置
  setCursorPosition = (ctrl, pos) => {
    ctrl.focus();
    ctrl.setSelectionRange(pos, pos);
  };

  // 值修改
  changeText = (e, field) => {
    const arr = utils.copy(this.state.submitParams);
    const type = {os: 'dataOsAssess', od: 'dataOdAssess'};
    arr.list[0][`${type[field]}`] = e;
    this.setState({
      submitParams: arr,
    });
  };

  render() {
    const {tabKey, submitMediaParams, submitParams} = this.state;
    return (
      <>
        <Tabs
          swipeable
          value={tabKey}
          onChange={this.onTableChange}
          className="examItemTabCont"
        >
          {['OD', 'OS'].map((type, index) => {
            // 获取对应眼别的检查项的指标列表
            // const examKeyList = examIndiList[`${type}List`] || []
            return (
              <Panel title={type} key={`${index + 1}`}>
                <div className="content">
                  <div className="other">{`${
                    index ? 'OS' : 'OD'
                  }评估内容`}</div>
                  <Cell>
                    {index ? (
                      <Input
                        rows={5}
                        maxLength={100}
                        type="text"
                        value={
                          submitParams?.list &&
                          submitParams?.list[0]?.dataOsAssess
                        }
                        placeholder="请输入"
                        onChange={(e) => this.changeText(e, 'os')}
                        ref={(ins) => (this.osRuleRef = ins)}
                      />
                    ) : (
                      <Input
                        rows={5}
                        maxLength={100}
                        type="text"
                        ref={(ins) => (this.odRuleRef = ins)}
                        placeholder="请输入"
                        value={
                          submitParams?.list &&
                          submitParams?.list[0]?.dataOdAssess
                        }
                        onChange={(e) => this.changeText(e, 'od')}
                      />
                    )}
                  </Cell>
                  <div className="examItem_box">
                    {typeList.map((val, index) => {
                      if (val.special) {
                        return (
                          <div
                            onClick={() => this.insertText(val)}
                            key={index}
                            className="exam_item"
                            style={{marginLeft: '-15px'}}
                          >
                            {val.label}
                          </div>
                        );
                      }
                      return (
                        <div
                          onClick={() => this.insertText(val)}
                          key={index}
                          className="exam_item"
                        >
                          {val.label}
                        </div>
                      );
                    })}
                  </div>

                  <ShowMediaCell
                    {...this.props}
                    fileEyeType={index + 1}
                    max={10}
                    data={submitMediaParams}
                    onSuccess={(record) => this.onMediaChange(record)}
                  />
                  <ShowMediaCell
                    {...this.props}
                    max={3}
                    mediaType="1" // 音视频类型 0-视频图片 1-音频 默认:0
                    fileEyeType={index + 1} // 类别 1-od;2-os
                    title="语音" // title; 默认:图片和视频
                    data={submitMediaParams} // 音视频数据 examFiles字段
                    onSuccess={(record) => this.onMediaChange(record)} // 删除和添加成功回调 返回处理后的音视频list
                  />
                </div>
              </Panel>
            );
          })}
        </Tabs>
      </>
    );
  }
}

export default TryAccessExamItem;
